import { useEffect, useState } from 'react';
import { ApiError } from '../../../../../shared/shared.api';
import { getTrailer } from '../../trailers/trailers.api';
import { getTruck } from '../../trucks/trucks.api';
import type { UnitVehicle } from '../units.paths';

export type VehicleRegistrationState = { status: 'loading' } | { status: 'loaded'; registration: string } | { status: 'not_found' } | { status: 'error' };

/** A truck's or trailer's registration by id, for an old address that names the vehicle by id. */
export function useVehicleRegistration(vehicleKind: UnitVehicle, id: string) {
  const [state, setState] = useState<VehicleRegistrationState>({ status: 'loading' });

  useEffect(() => {
    let cancelled = false;
    const read = vehicleKind === 'truck' ? getTruck(id) : getTrailer(id);
    read
      .then((vehicle) => {
        if (!cancelled) setState({ status: 'loaded', registration: vehicle.registration });
      })
      .catch((err) => {
        if (!cancelled) setState({ status: err instanceof ApiError && (err.status === 404 || err.status === 400) ? 'not_found' : 'error' });
      });
    return () => {
      cancelled = true;
    };
  }, [vehicleKind, id]);

  return state;
}
